{
  "aboutDeviceControls": "About Device Controls",
  "actionLabel": "Action: ",
  "adminUser": "Admin User",
  "automation": "Automation",
  "command": "Command",
  "conditionLabel": "Condition: ",
  "confirmDeviceActionCannotCancelWarning": "This action cannot be canceled.",
  "confirmDeviceActionIAcceptText": "I accept responsibility for the outcome of this action",
  "confirmDeviceActionSuccessToast": "Request sent to device ",
  "confirmDeviceActionSuccessToastWithDeviceName": "Request sent to device {{deviceName}}",
  "confirmDeviceActionWarningDescription": "Controlling a circuit manually can have dangerous consequences. By performing this action, you accept all responsibility for any harm or damage that may result.",
  "confirmationRequired": "Confirmation Required",
  "controlPanelHelpContent": "You can send commands to directly control the switch (also known as the relay) on your device. These commands may have different effects based on the way you installed your device, and the installation type of your equipment.\n\nTo use these controls, you must have permission to control devices remotely. If you are a manager at your farm, you can deny or grant access to these features from account settings.",
  "controls": "Controls",
  "deviceActionHistoryListEmpty": "No command history found for this device",
  "deviceActionHistoryListTitle": "Action History",
  "deviceActionHistoryListHelpBodyText": "Display previous actions performed on a device. This list includes automated actions performed by FarmHQ, as well as manual actions performed by users.",
  "deviceControls": "Device Controls",
  "result": "Result",
  "system": "System",
  "time": "Time",
  "triggeredBy": "Triggered By",
  "turnWaterOff": "Turn water off",
  "turnWaterOn": "Turn water on",
  "unknownAction": "Unknown Action",
  "warning": "Warning"
}
